
import axios from 'axios';
import Cookies from 'js-cookie';
import LoginAuth from '../services/auth.service';
const axiosInstance = axios.create({
    
    // headers: {
    //     'Content-Type': 'application/json'
    // }
});


// Add an interceptor for all requests

axiosInstance.interceptors.request.use(config => {
const admoneCookie = Cookies.get('admone_cp');

    if (admoneCookie) {
        try {
          
            const tokens = JSON.parse(admoneCookie);
            const accessToken = tokens.accessToken;

            if (accessToken) {
               
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
        } catch (error) {
            console.error('Failed to parse admone cookie:', error.message);
        }
    } else {
        console.log('No admone cookie found');
    }

    return config;
}, error => {
   
    return Promise.reject(error);
});





// The API answers 401 with sessionExpired: true when the session is over:
// logged out elsewhere, password changed or reset, token expired. Clear it here
// and go to login.
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 && error.response?.data?.sessionExpired) {
            LoginAuth.clearLocalSession();
            if (!window.location.pathname.startsWith('/login')) {
                const redirect = encodeURIComponent(window.location.pathname + window.location.search);
                window.location.href = `/login?redirect=${redirect}`;
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;